<div class="popup-confirmacion-container">
  <!-- Header azul con título y botón cerrar -->
  <div class="popup-header">
    <span class="popup-titulo">{{ titulo }}</span>
    <mat-icon class="popup-close-icon" (click)="onClose()">close</mat-icon>
  </div>

  <!-- Cuerpo con el texto de la pregunta -->
  <div class="popup-body">
    <p class="popup-texto">{{ texto }}</p>
  </div>

  <!-- Footer con los dos botones -->
  <div class="popup-footer">
    <button 
      type="button"
      class="btn-action btn-confirmacion btn-si"
      (click)="onSi()">
      {{ textoBotonSi }}
    </button>
    <button 
      type="button"
      class="btn-action btn-confirmacion btn-no"
      (click)="onNo()">
      {{ textoBotonNo }}
    </button>
  </div>
</div>
